import React from 'react';
import styled from 'styled-components';

const StyledButton = styled.button`
  background: none;
  border: none;
  text-decoration: none;
  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
  color: white;
  width: 100%;
  display: block;
  cursor: pointer;
  padding: 0;
  font: inherit;
  text-align: left;
`;

const CustomToastWithAction = (props) => {
  return <StyledButton onClick={props.onClick}>{props.text}</StyledButton>;
};

export default CustomToastWithAction;
